export default "__VITE_ASSET__CGOdJacK__"